import * as React from 'react'
import BraftEditor, {
  BraftEditorProps,
  ControlType,
  ExtendControlType,
} from 'braft-editor'
import { ContentUtils } from 'braft-utils'
import { qnToken } from 'services/api/upload'
import * as qiniu from 'qiniu-js'
import 'braft-editor/dist/index.css'
import { Switch, Icon } from 'antd'

let isFirstEnter = true // braft-editor 有个初次进入就会执行 change 的 bug，可以在组件中通过状态锁标识组件是否是第一次进入

const controls: ControlType[] = [
  'undo',
  'redo',
  'bold',
  'italic',
  'underline',
  'strike-through',
  'text-color',
  'superscript',
  'subscript',
  'separator',
  'font-size',
  'line-height',
  'letter-spacing',
  'headings',
  'separator',
  'remove-styles',
  'text-indent',
  'text-align',
  'separator',
  'list-ul',
  'list-ol',
  'blockquote',
  'code',
  'link',
  'separator',
  'media',
]

interface RichEditorProps extends BraftEditorProps {
  onContentChange(content: string): void
}

interface RichEditorState {
  editorState: any
  styleChecked: boolean
}

export default class RichEditor extends React.Component<
  RichEditorProps,
  RichEditorState
> {
  state = {
    editorState: BraftEditor.createEditorState(null),
    styleChecked: true,
    init: true,
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.init) {
      return {
        init: false,
        editorState: BraftEditor.createEditorState(nextProps.defaultValue),
      }
    }
    return null
  }

  componentWillUnmount() {
    isFirstEnter = true
  }

  onChange = (editorState: any): void => {
    if (isFirstEnter) {
      isFirstEnter = false
      return
    }
    this.setState({ editorState })

    const { onContentChange } = this.props
    if (onContentChange) {
      onContentChange(!editorState.toText() ? '' : editorState.toHTML())
    }
  }

  onStyleSwitchChange = (styleChecked: boolean): void => {
    this.setState({
      styleChecked,
    })
  }

  clearContent = (): void => {
    const editorState = ContentUtils.clear(this.state.editorState)
    this.setState({ editorState })

    const { onContentChange } = this.props
    if (onContentChange) {
      onContentChange(editorState.toHTML())
    }
  }

  // 得到上传文件的文件名
  getUpLoadFileName = file => {
    const firstName = file.name.split('.')[0]
    const type = file.name.split('.')[1]
    const time = `${new Date().getTime()}`
    const other = 'exam_system_backstage'
    return `${other}_${firstName}_${time}.${type}`
  }

  // 文件上传
  myUploadFn = async param => {
    const file = param.file
    const key = this.getUpLoadFileName(file)
    const res = await qnToken()
    const token = res.data.meta.token
    const domain = res.data.meta.domain

    // const putExtra = {
    //   fname: key,
    //   params: {},
    //   mimeType: null,
    // }
    // const config = {
    //   useCdnDomain: true,
    //   // region: qiniu.region.z0,
    // }
    const observable = qiniu.upload(file, key, token)
    const observer = {
      next(result) {
        param.progress(result.percent)
      },
      error(error) {
        param.error({
          msg: error.message,
        })
      },
      complete(result) {
        param.success({
          url: `${domain}/${result.key}`,
          meta: {
            id: result.key,
            title: result.key,
          },
        })
      },
    }
    observable.subscribe(observer)
  }

  render() {
    const { className } = this.props
    const { editorState, styleChecked } = this.state
    const extendControls: ExtendControlType[] = [
      {
        key: 'antd-switch-style',
        type: 'component',
        component: (
          <span className="control-item media button">
            样式粘贴：
            <Switch
              size="small"
              checked={styleChecked}
              onChange={this.onStyleSwitchChange}
            />
          </span>
        ),
      },
      {
        key: 'clear-editor',
        title: '清空内容',
        type: 'button',
        text: <Icon type="delete" onClick={this.clearContent} />,
      },
    ]

    return (
      <>
        <BraftEditor
          className={className}
          controls={controls}
          onChange={this.onChange}
          // triggerChangeOnMount={false}
          stripPastedStyles={styleChecked}
          extendControls={extendControls}
          value={editorState}
          media={{
            uploadFn: this.myUploadFn,
            accepts: {
              image:
                'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
              video: 'video/mp4',
              audio: false,
            },
          }}
        />
      </>
    )
  }
}
